import React from "react";
import { ChevronRight } from "lucide-react";

interface BackButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  disabled = false,
  label = "Back",
}) => {
  return (
    <button
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-100 text-[#885ABB] hover:bg-[#885ABB]/5 transition-colors font-bold text-[10px] uppercase disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <ChevronRight className="rotate-180" size={12} /> {label}
    </button>
  );
};

export default BackButton;
